<template>
  <div v-show="recommend">
    <div class="recommend-bg">
      <p class="recommend-title">{{this.$t('common.site')}}<span>{{this.$t('common.recommend')}}</span></p>
      <div class="ranking-img-bg" @click="contentPage(recommendFirst.id)">
        <div class="ranking-img-title">
          <span>{{recommendFirst.title}}</span>
        </div>
        <img src="/static/default.jpg"class="ranking-img" v-if="recommendFirst.thumbnail ==null || recommendFirst.thumbnail ==''"/>
        <img :src="recommendFirst.thumbnail" class="ranking-img" v-else>
      </div>
      <ul class="recommend-list">
        <li v-for="item in recommendContent" @click="contentPage(item.id)">{{item.title}}</li>
      </ul>
    </div>
  </div>

</template>

<script>
  import axios from '@/axios'

  export default {
    name: "recommend",
    data() {
      return {
        recommendContent: [],
        recommendFirst: [],
        recommend:true
      }
    },
    components: {},
    created: function () {
      this.getRecommendList();
    },
    methods: {
      // 推荐排行请求数据
      getRecommendList() {
        let _this = this;
        axios.get(this.$store.state.apiBasePath + "/recommend/list", {params: {size: 6}})
          .then(function (res) {
            if (res.data.code === 200) {
              let resData = res.data.data.content;
              let Length = resData.length;
              //第一条带图数据
             if(Length == 0){
               // _this.recommend=false;
             } else if (Length > 0) {
                _this.recommendFirst = resData[0];
              }else if (Length > 1) {
                for (let i = 1; i < Length; i++) {
                  _this.recommendContent.push(resData[i]);
                }
              }
            }
          })
      },


      // 页面跳转
      contentPage(id) {
        this.$router.push({path: "/contentPage/" + id, query: {url: 'article'}})
      },


    },

  }
</script>

<style scoped>
  .recommend-bg {
    width: 360px;
    border: #e5e5e5 1px solid;
    margin-bottom: 10px;
    background: #fff;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
    font-size: 14px;
  }

  .recommend-list li:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li:hover {
    text-decoration: underline;
    color: #379ce9;
    cursor: pointer;
  }

  .recommend-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    padding: 5px 0;
    margin: 10px 10px;
    border-bottom: #ddd 1px solid;
  }

  .ranking-img-bg {
    position: relative;
    height: 160px;
  }

  .ranking-img-bg img {
    width: 100%;
    height: 160px;
  }

  .ranking-img-bg:hover {
    cursor: pointer;
  }

  .ranking-img-title {
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: left;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
  }

  .ranking-img-title span {
    margin: 0 15px;
    display: block;
    font-size: 14px;
  }



  @media screen and (max-device-width: 1024px) {
    .recommend-bg{width: auto}
  }


</style>



// WEBPACK FOOTER //
// src/components/comment/recommend.vue